exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".oasispay-server-content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", "", {"version":3,"sources":["/project/slimvue-website/website/components/servers/Server1.vue"],"names":[],"mappings":"AACA,yBAA2B,oBAAqB,AAAC,oBAAqB,AAAC,aAAc,AAAC,uBAAwB,AAAC,oBAAqB,AAAC,2BAA4B,AAAC,yBAA0B,AAAC,sBAAuB,AAAC,kBAAoB,CACxO","file":"Server1.vue","sourcesContent":["\n.oasispay-server-content { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-pack: start; -ms-flex-pack: start; justify-content: flex-start; -webkit-box-align: center; -ms-flex-align: center; align-items: center;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-659d72c4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./website/components/servers/Server1.vue
// module id = fyA/
// module chunks = 0